import { defineComponent as _defineComponent } from 'vue'
import Tooltip from '@/components/ui/tooltip/Tooltip.vue'
import { Icon } from '@iconify/vue2'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpTooltip',
  props: {
    title: null,
    description: null
  },
  setup(__props: any) {



return { __sfc: true,Tooltip, Icon }
}

})